import { Player, createCancelPromocodeMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type CancelPromocodeModel = ConfirmModalModel<Player, { playerId: number }, Player>;

export const createCancelPromocodeModel = (): CancelPromocodeModel => {
	const cancelPromocodeMutation = createCancelPromocodeMutation();

	const model = createConfirmModalModel<Player, { playerId: number }, Player>({
		modalData: declareModalData<Player>(),
		mutation: cancelPromocodeMutation,
		mapModalData: ({ id }) => ({ playerId: id }),
		successMessageKey: 'cancel-promocode.success',
	});

	return model;
};
